/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Main from './app/main';
import * as serviceWorker from './serviceWorker';

/* ReactDOM.render(
  <span>
    <Main />
  </span>,
  document.getElementById('root'),
); */

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <span>
    <Main />
  </span>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
